/**
 * AuditSessionStatusBadge Component
 *
 * Reusable status badge component for audit sessions with consistent styling
 * and color coding across the entire audit domain.
 */

import { formatStatus } from '@internal-audit/shared/utils/formatHelpers';

import * as styles from './AuditSessionStatusBadge.css';

interface AuditSessionStatusBadgeProps {
  status: string;
  className?: string;
}

// Helper function to get status color class
function getStatusColor(status: string): string {
  switch (status.toLowerCase()) {
    case 'active':
    case 'in_progress':
      return styles.statusActive;
    case 'completed':
      return styles.statusCompleted;
    case 'expired':
    case 'pending':
    case 'skipped':
      return styles.statusExpired;
    default:
      return styles.statusActive;
  }
}

export function AuditSessionStatusBadge({ status, className }: AuditSessionStatusBadgeProps) {
  const statusColorClass = getStatusColor(status);
  const combinedClassName = className ? `${styles.statusBadge} ${statusColorClass} ${className}` : `${styles.statusBadge} ${statusColorClass}`;

  return <div className={combinedClassName}>{formatStatus(status)}</div>;
}
